import './styles.scss'
import Label from "components/Label";
import ProxyManagementItem from './ProxyManagementItem';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Button from 'components/common/Buttons';
import { getImageUrl } from 'helpers';
import { useEffect, useRef, useState } from 'react';
import { useAnimation } from 'hooks/useAnimation';
import { useGSAP } from '@gsap/react';
import gsap from 'gsap'
import useMediaQuery from 'hooks/useMediaQuery';
// import { useSelector } from 'react-redux';
// import { selectFirstLoading } from 'store/slices/UI-Slice';
import card_one_bg from 'assets/backgrounds/proxyItem1-mob1.png'
import card_two_bg from 'assets/backgrounds/proxyItem1-mob2.png'
import card_three_bg from 'assets/backgrounds/proxyItem1-mob3.png'
import dashBordBg from 'assets/backgrounds/EasyProxy.svg'
import EasyProxyMob from 'assets/backgrounds/EasyProxyMob.svg'
// import { LazyLoadImage } from 'react-lazy-load-image-component';


const ProxyManagement = ({ dashboard, isLoading }) => {
    const isTablet = useMediaQuery('max-width: 768px')
    const container = useRef();
    const [imagesLoaded, setImagesLoaded] = useState(false);

    const {
        // id,
        tag,
        title,
        button_text,
        button_link,
        card_three,
        card_two,
        card_one,
        image,
    } = dashboard


    const possibilities = [
        {
            data: card_one,
            bg: card_one_bg,
        },
        {
            data: card_two,
            bg: card_two_bg,
        },
        {
            data: card_three,
            bg: card_three_bg,
        }
    ]

    useEffect(() => {
        const mainImage = new Image();
        mainImage.src = getImageUrl(dashboard.image);
        mainImage.onload = () => {
            setImagesLoaded(true);
        };

        return () => {
            mainImage.onload = null; // Cleanup event listener
        };
    }, [dashboard.image]);

    useAnimation({
        items: ['.management h2', '.management .position-relative', '.management-button'],
        container,
        dependencies: [isLoading],
    })

    const speed = [-75, -250, -150];

    gsap.registerPlugin(ScrollTrigger);
    useGSAP(

        () => {
            if (!isTablet && !isLoading && imagesLoaded) {
                let targets = gsap.utils.toArray(['.management-item']);
                targets.forEach((item, index) => {
                    gsap.to(item, {
                        yPercent: speed[index],
                        ease: 'none',
                        scrollTrigger: {
                            trigger: ".management-container",
                            scrub: 1,
                        },
                    });
                });
            }
        },
        { dependencies: [isTablet, isLoading, imagesLoaded], scope: container, revertOnUpdate: true },

    );




    const speedBg = [-80];

    gsap.registerPlugin(ScrollTrigger);
    useGSAP(
        () => {
            if (!isLoading && imagesLoaded) {
                let targets = gsap.utils.toArray(['.management__bg']);
                targets.forEach((item, index) => {
                    gsap.to(item, {
                        yPercent: speedBg[index],
                        ease: 'none',
                        scrollTrigger: {
                            trigger: item,
                            scrub: 1,
                        },
                    });
                });
            }
        },
        { dependencies: [isLoading, imagesLoaded], scope: container, revertOnUpdate: true },

    );
    const dashbordMainImage = getImageUrl(image);
    if (!card_one || !card_two || !card_three || !image) return
    return dashbordMainImage && (
        <section ref={container} className="container management">
            <Label text={tag} type="outline" />
            <h2>{title}</h2>

            <div className='position-relative'>
                <div className='management-container'>
                    {/* <LazyLoadImage src={dashbordMainImage}
                        width={1100} height={650}
                        className='management-main-image'
                        alt="Image Alt"
                    /> */}
                    <img src={dashbordMainImage} alt="" className='management-main-image' />
                </div>
                <div className='management-container-items'>
                    {
                        possibilities?.map((item, index) => (
                            <ProxyManagementItem key={index} data={item.data} bg={item.bg} />
                        ))
                    }
                </div>
            </div>
            <div className='management-button'>
                <Button text={button_text} type='white' to={button_link} />
            </div>
            <img className='management__bg' src={isTablet ? EasyProxyMob : dashBordBg} alt="" />
        </section>
    );
}

export default ProxyManagement;